/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import axios from "axios";
import { APIGateways } from "../../../utility/APIGateways";
import { getAuthHeader } from "../../../utility/auth";
import { v2, errorToObject } from "@prftesp/cle-logger";
import errorCodes from "../../../utility/errorCodes";

const COMPONENT_NAME = "Admin services/UserService";

/**
 * Gets all of the Agent statuses
 */
export const listAgentStatuses = async () => {
	try {
		let response = await axios.get(`${APIGateways.connectLookupsEndpoint}/agentStatuses`, {
			headers: await getAuthHeader(),
		});
		return response.data.AgentStatusSummaryList;
	} catch (error) {
		v2.error(`Error getting agent statuses`, {
			additionalData: {
				error: errorToObject(error),
			},
			logCode: errorCodes.GET_AGENT_STATUSES_API_ERROR,
			componentName: COMPONENT_NAME,
		});
		throw error;
	}
};

/**
 * Gets configured status alerts list.
 */
export const listStatusAlertsConfigs = async () => {
	try {
		let response = await axios.get(`${APIGateways.statusAlertsEndpoint}`, {
			headers: await getAuthHeader(),
		});
		return response.data;
	} catch (error) {
		v2.error(`Error getting configured status alerts`, {
			additionalData: {
				error: errorToObject(error),
			},
			logCode: errorCodes.GET_AGENT_STATUS_ALERTS_API_ERROR,
			componentName: COMPONENT_NAME,
		});
		throw error;
	}
};

/**
 * Sends the list of new status alert configurations to the backend lambda
 * where they will be updated, removed, or created in the dynamo.
 * @param {Object} statusAlerts The array of status alerts.
 * @returns The updated list of status alerts
 */
export const updateStatusAlertsConfigs = async (statusAlert) => {
	try {
		let response = await axios.post(`${APIGateways.statusAlertsEndpoint}`, statusAlert, {
			headers: await getAuthHeader(),
		});
		return response.data;
	} catch (error) {
		v2.error(`Error getting configured status alerts`, {
			additionalData: {
				error: errorToObject(error),
			},
			logCode: errorCodes.UPDATE_AGENT_STATUS_ALERTS_API_ERROR,
			componentName: COMPONENT_NAME,
		});
		throw error;
	}
};

export const deleteStatusAlertsConfigs = async (statusAlertId) => {
	try {
		let response = await axios.delete(`${APIGateways.statusAlertsEndpoint}/${statusAlertId}`, {
			headers: await getAuthHeader(),
		});
		return response.data;
	} catch (error) {
		v2.error(`Error deleting Status alerts`, {
			additionalData: {
				error: errorToObject(error),
				statusAlertId,
			},
			logCode: errorCodes.DELETE_DISPOSITION_API_ERROR,
			componentName: COMPONENT_NAME,
		});
		throw error;
	}
};
